import { Directive } from '@angular/core';

@Directive( {
    selector: '[ridangoSuffix]'
    // tslint:disable-next-line:directive-selector
    // selector: 'ridango-suffix'
} )
export class SuffixDirective {

    constructor() { }

}
